import React, { useEffect, useRef } from "react";
import "./cropper.scss";

export const Cropper = ({ src, getBlob, closeCropper }) => {
    //console.log("src", src);
    
    const getBase64 = (src) => {
        if (src) {
            getBlob(src);
        }
        closeCropper();
    };

    return (
        src && (
            <>
                <img
                    src={src}
                    alt="preview"  
                    className="!w-[100px] !h-[100px] !object-cover !rounded-full" 
                />
                <div className="events">
                    <a
                        onClick={closeCropper}
                        className="cancel"
                        href="javascript:void(0);"
                    >
                        {/* <i className="icon-cancel"></i> */}
                        Cancel
                    </a>
                    <a
                        className="save"
                        href="javascript:void(0);"
                        onClick={() => getBase64(src)}
                    >
                        {/* <i className="icon-check"></i> */}
                        Save
                    </a>
                </div>
            </>
        )
    );
};